module.exports = __webpack_public_path__ + "dash_20_app_assets/img/signout.9a19bf67.png";